import axios, { AxiosError } from 'axios';
import { config } from 'CONFIG';
import { HttpClientBuilder } from './clientBuilder';
import { STM } from './interceptors/stm';
import { RequireAuth } from './interceptors/requiresAuth';
import { Retry } from './interceptors/retry';
import { ApmTraceInterceptor } from './interceptors/apmTrace';
import { IRequestConfig } from './interface';
export * as Error from './error';
import { axiosErrorLog, ErrorLogKey } from '@reolink/web.fe.http-client';

export class HttpManager {

    public constructor() {

        axios.defaults.baseURL = config.baseUrl + config.version;
        axios.defaults.timeout = 3e4;

    }

    private _globalInterceptorsInit( clientBuilder: HttpClientBuilder ): HttpClientBuilder {

        clientBuilder
            .usePlugin( ApmTraceInterceptor )
            .usePlugin( RequireAuth )
            .usePlugin( Retry )
            // build 之前处理 client
            .clientDeferSetter(( httpClient ) => {

                httpClient._client.interceptors.response.use( undefined, ( err: AxiosError ) => {

                    console.error( err + '' );

                    axiosErrorLog( err as any, {
                        saveLogConfig: {
                            errorKey: ErrorLogKey
                        }
                    });
                    return Promise.reject( err );

                });

            });

        return clientBuilder;

    }

    public createBuilder( options?: IRequestConfig ): HttpClientBuilder {

        const builder = new HttpClientBuilder( options );

        this._globalInterceptorsInit( builder );

        return builder;

    }

}

const manager = new HttpManager();
const builder = manager.createBuilder();

export const createBuilder = ( options: IRequestConfig ): HttpClientBuilder => manager.createBuilder( options );

export const httpManager = builder.buildClient();
export const stmHttpClient = builder.usePlugin( STM ).buildClient();
// 不带任何上下文的 client
export const pureHttpClient = new HttpClientBuilder({
    baseURL: ''
}).disableGlobalDefaults().buildClient();
